<div class="replace_plant_block">
    <div class="title_heading">
        <h1>Replace Plant</h1>
     </div>
        <!-- content -->
         <div class="k-d-flex k-justify-content-stretch k-gap-2">
             <div class="old_plant_name">
               
                   <kendo-label  class="replacement_lable" [for]="sizes" text="Old Plant Name"></kendo-label>
                    <div class="k-form-field-wrap">
                        <kendo-dropdownlist class="replacekendo-dropdownlist"
                            #sizes
                           [(ngModel)]="selectedOldPlant"
                            [data]="filterPlantNameList"
                            [filterable]="true"
                            textField="plantname"
                            valueField="plantname"
                            (filterChange)="handleFilter($event)"
                        >
                        </kendo-dropdownlist>
                    </div> 
                    <div class="show_oldplant_details" *ngIf="selectedOldPlant">
                        <ng-container *ngFor="let item of selectedOldPlant.plantDetails">
                            <div>
                            {{item?.category}} {{item?.categoryCount}}
                            </div>
                        </ng-container>
                    </div>
             </div>
             <div class="new_plant_name">
                <kendo-label class="replacement_lable" [for]="sizes" text="New Plant Name"></kendo-label>
                <div class="k-form-field-wrap">
                    <kendo-dropdownlist  class="replacekendo-dropdownlist"
                        #sizes
                        [(ngModel)]="selectedNewPlant"
                        [data]="filterPlantNameList"
                        [filterable]="true"
                        textField="plantname"
                        valueField="plantname"
                        (filterChange)="handleFilter($event)"
                    >
                    </kendo-dropdownlist>
                </div> 
                <div class="show_newplant_details" *ngIf="selectedNewPlant">
                    <ng-container *ngFor="let nItem of selectedNewPlant.plantDetails">
                        <div>
                        {{nItem?.category}} {{nItem?.categoryCount}}
                        </div>
                    </ng-container>
                </div>
             </div>
         </div>
         <div class="k-d-flex k-justify-content-end k-gap-2 m-10">
            <button kendoButton class="btn-save k-button-lg" (click)="replacePlantNames()">Replace plant</button>
 
         </div>

</div>